import { withTranslation } from "react-i18next";

import React from 'react';
/* import { GoogleLogin } from 'react-google-login-component'; */
// import FacebookLogin from 'react-facebook-login';
import SellerUser from '../../Models/SellerUser';
// import TiSocialFacebookCircular from 'react-icons/lib/ti/social-facebook-circular';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
class FacebookLoginItem extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const responseFacebook = (response) => {
            console.log(response);
            let data = {
                email: response.email,
                name: response.name,
                user_type: this.props.id
            }
            SellerUser.checkEmail(data).then(res => {
                if (parseInt(res.data.status) === 200) {
                    if (res.data.payload.user_type_id === 1) {
                        window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                        this.props.history.push("/buyer-dashboard")
                    } else if (res.data.payload.user_type_id === 2) {
                        window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                        this.props.history.push("/seller-dashboard")
                    } else if (res.data.payload.user_type_id === 3) {
                        window.localStorage.setItem('info', JSON.stringify(res.data.payload))
                        this.props.history.push("/affiliator-dashboard")
                    }
                } else {
                    alert(this.props.t('0'))
                }
            })
        }
        // const responseGoogle = (response) => {
        //     console.log(this.props.id)
        //     console.log("google console");
        //     console.log(response);
        //     console.log(response['profileObj'].email);
            // console.log(response['profileObj'].name);
            // let data = {
            //     email: response['profileObj'].email,
            //     name: response['profileObj'].name,
            //     user_type: this.props.id
            // }
            // SellerUser.checkEmail(data).then(res => {
            //     if (parseInt(res.data.status) === 200) {
            //         if (res.data.payload.user_type_id === 1) {
            //             window.localStorage.setItem('info', JSON.stringify(res.data.payload))
            //             this.props.history.push("/buyer-dashboard")
            //         } else if (res.data.payload.user_type_id === 2) {
            //             window.localStorage.setItem('info', JSON.stringify(res.data.payload))
            //             this.props.history.push("/seller-dashboard")
            //         } else if (res.data.payload.user_type_id === 3) {
            //             window.localStorage.setItem('info', JSON.stringify(res.data.payload))
            //             this.props.history.push("/affiliator-dashboard")
            //         }
            //     } else {
            //         alert(this.props.t('0'))
            //     }
            // })

        // }

        return (
            <div>
                <FacebookLogin
                    appId="399961627592264"
                    cssClass="my-facebook-button-class"
                    // cssClass="my-facebook-button-class"
                    disableMobileRedirect={true}
                    icon="fa-facebook"
                    render={renderProps => (
                        <button onClick={renderProps.onClick} className="social_button" ><img alt="" src={require("../../assets/images/Flogo2.png")} height="100%" width='100%' /></button>
                    )}
                    autoLoad={false}
                    fields="name,email,picture"
                    callback={responseFacebook}
                />
            </div>
        );
    }

}

export { FacebookLoginItem };


 FacebookLoginItem = withTranslation('src_Components_Login_FacebookLoginItem')(FacebookLoginItem);